// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"27e79a1bd8d0cd6d","5405":"701c818143e705a1","5626":"66336957ddf21e25","7077":"073d849435a7e93d"}[chunkId] + ".css";
};